<template>
  <v-container class="ctnr input-text-size">
    <loader v-if="loading"/>
    <div class="header">
        <v-row align="center">
          <v-col cols="auto">
            <span class="label-left">Select File :</span>
          </v-col>
          <v-col cols="4">
            <v-combobox hide-details dense
            class="input-text-size" outlined label="File Name" :items="getListNames"
              v-model="criteriaState.name" @input="searchByCriteria" item-value="text">
            </v-combobox>
          </v-col>
          <v-col cols="auto">
            <v-btn class="input-text-size" small
            @click="handlePickListRecords" color="primary">Import Pick List</v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn class="input-text-size" small
            @click="handleMultipleDeleteByFileName" color="primary">Delete list</v-btn>
          </v-col>
          <v-col v-if="isSuperAdmin" cols="auto">
            <v-btn class="input-text-size" small
            @click="openCronDialog" color="secondary">Add Cron Job</v-btn>
          </v-col>
          <v-col cols="3">
            <v-text-field hide-details dense class="input-text-size" outlined
              v-model="jumpToValue" :label="jumpToLabel" :disabled="!jumpFieldSupported"
              @keyup.enter="handleJumpTo" />
          </v-col>
        </v-row>
      <v-col cols="4" class="totals-display">
        <span class="total-item">Total Records: {{ this.selectedRecordsCount }}</span>
        <span class="total-item">Total Parcels: {{ this.selectedParcelCount }}</span>
      </v-col>
    </div>
    <v-row>
      <v-col cols="8">
        <div class="list-btns-ctnr">
          <CRUDList ref="crudList" :canAdd="true" :canMove="true"
          :canEdit="false" :canSave="true" :showSelect="true" :canDelete="true"
            :enableFixedHeaders="true" :displayTopPagination="false" :defaultSortBy="defaultSortBy"
            :baseCrudKey="baseCrudKey"
            :formatPidPositions="formatPidPositions"
            tableWrapperDynamicClassname='elevation-3 ma-3 pa-1 taxroll-table-wrapper'
            tableDynamicClassname='taxroll-custom-table' tableDynamicHeight='300' :headers="headers"
            :selectedItems="selectedItems" :canMultipleDelete="true"
            @emitSelectedItem="emitSelectedItem" @loadCRUDList="handletrWorkFileRecords"
            @upsertItem="upsertTransaction" @handleMultipleDelete="handleMultipleDelete"
            @onDoubleClicked="handleDoubleClick"
            @emitDeleteRowItem="deleteItem" dialogDynamicWidth="30vw"
            :loadingData="gridLoading.flag" :loadingText="gridLoading.text">
            <template v-slot:[`editedItem`]="{}">
              <BrowseTREditedItemVue :baseCrudKey="baseCrudKey" />
            </template>
          </CRUDList>

        </div>
      </v-col>
      <v-col cols="4">
        <div class="list-action-btns">
          <v-row class="align-center ">
            <v-col cols="3">
              <h4>List Actions:</h4>
            </v-col>
            <v-col cols="9">
              <v-select hide-details dense class="input-text-size" outlined label="Select Actions"
                :items="actionButtons" item-value="value" @change="onChangeActionVal"
                :disabled="!criteriaState.name">
              </v-select>
            </v-col>
          </v-row>

          <div class="list-actions-ref" v-show="selActionIdex != 0">
            <v-row dense v-show="selActionIdex == 1">
              <v-col cols="4">
                <CommonDropDowns :isItTaxYear=true
                @change="dataFromCommonDropDowns" :criteriaState="editedItem" />
              </v-col>
              <v-col cols="6" class="flex">
                <CommonDropDowns :isItTaxFee="true"
                :taxFeeRequired="true" @change="dataFromCommonDropDowns"
                  :taxFeeNumValue="editedItem.feeNumber" />
                <v-text-field outlined class="input-text-size pa-0 mb-n5" label="Fee Amount"
                  v-model="editedItem.feeAmount"
                  @blur="roundAmount" @focus="amountToNum(), $event.target.select()"
                  :rules="rules" />
              </v-col>
              <v-row>
                  <v-col cols="6">
                    <ClarionDateControl class="input-text-size pa-0 mt-n6"
                    label="Effective Date"
                    :isRequired="false" v-model="effectiveDate" :isToggle="false"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="d-flex align-center">
                    <v-checkbox
                      v-model="addOneFeePerParcel"
                      label="Add one fee per parcel"
                      class="input-text-size mt-n6"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="6" class="d-flex align-center">
                    <v-checkbox
                      v-model="addOneFeePerOwner"
                      label="Add one fee per owner"
                      class="input-text-size mt-n6"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>
              <v-col cols="4">
              </v-col>

            </v-row>
            <!-- mtg -->
            <div v-show="selActionIdex == 2">
              <v-row class="align-center">
                <v-col cols="3">
                  <h4>Mortgage Code : </h4>
                </v-col>
                <v-col cols="9">
                  <CommonDropDowns :isItMtgCode=true @change="dataFromCommonDropDowns" />
                </v-col>
              </v-row>
            </div>
            <!-- status -->
            <div v-show="selActionIdex == 3 || selActionIdex == 9">
              <v-row class="align-center">
                <v-col cols="3">
                  <h4>Status Code:</h4>
                </v-col>
                <v-col cols="9">
                  <CommonDropDowns :isItstaCode=true @change="dataFromCommonDropDowns" />
                </v-col>
              </v-row>
            </div>
            <div v-show="selActionIdex == 4">
              <v-row densev-row class="align-center">
                <v-col cols="3">
                  <h4>Penalty Start Date :</h4>
                </v-col>
                <v-col cols="9">
                  <ClarionDateControl class="input-text-size mt-n2"
                  label="Penalty Date" :isRequired="false"
                    :isIsoDate="true" v-model="penaltyStartDate" />
                </v-col>
              </v-row>
            </div>
            <div v-show="selActionIdex == 5">
              <div>
                <h4>Add Comment :</h4>
                <v-textarea hide-details rows="2" label="Write something.."
                outlined v-model="getComment"
                  class="input-text-size mt-1"
                  v-textAreaUppercase=globalSettingItem.conEverythingToCaps></v-textarea>
              </div>
            </div>
            <v-row dense v-show="selActionIdex == 7">
              <v-col cols="4">
                <CommonDropDowns :isItTaxYear=true
                @change="dataFromCommonDropDowns" :criteriaState="editedItem" />
              </v-col>
              <v-col cols="6">
                <CommonDropDowns :isItTaxFee="true"
                :taxFeeRequired="true" @change="dataFromCommonDropDowns"
                  :taxFeeNumValue="editedItem.feeNumber" />
              </v-col>
            </v-row>
            <div v-show="selActionIdex == 13">
              <div>
                <v-text-field class="input-text-size pa-0" label="Sale Year" type="number"
                v-model.number="resaleCriteriaItem.saleYear" />
                <ClarionDateControl class="input-text-size mt-n3" :isToggle="false"
                  v-model="resaleCriteriaItem.saleDate" label="Date of Sale" />
                <ClarionDateControl class="input-text-size mt-n3" :isToggle="false"
                  v-model="resaleCriteriaItem.publicationDate" label="Date of Publication" />
                <ClarionDateControl class="input-text-size mt-n3" :isToggle="false"
                  v-model="resaleCriteriaItem.penaltyDate" label="Penalty Date" />
              </div>
            </div>
          </div>
          <div class=" mt-4" v-show="selActionIdex != 0">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary"
                 small rounded :loading="isActionRunning" :disabled="isActionRunning"
                 @click="handleActions()">
                  Go
                </v-btn>
              </template>
              <span>Go for action</span>
            </v-tooltip>
          </div>
          <!-- Statement print job queue -->
          <div v-if="statementJobs.length" class="stmt-queue mt-3">
            <div
              v-for="job in statementJobs"
              :key="job.localId"
              class="stmt-queue-row elevation-1"
            >
              <div class="stmt-queue-row__left">
                <v-progress-circular
                  v-if="isJobRunning(job)"
                  :value="jobPct(job)"
                  :size="20"
                  :width="2"
                  :color="job.status === 'queued' ? 'grey' : 'primary'"
                  :indeterminate="job.status === 'queued'"
                />
                <v-icon v-else-if="job.status === 'complete'" color="success" size="18">
                  {{ icons.mdiCheckCircle }}
                </v-icon>
                <v-icon v-else color="error" size="18">{{ icons.mdiAlertCircle }}</v-icon>
              </div>
              <div class="stmt-queue-row__body">
                <div class="stmt-queue-row__label">{{ job.label }}</div>
                <div
                  v-if="job.status === 'queued'"
                  class="stmt-queue-row__count"
                >Queued — waiting for an earlier run to finish</div>
                <div
                  v-else-if="job.status === 'running' || job.status === 'pending'"
                  class="stmt-queue-row__count"
                >{{ job.processed.toLocaleString() }} / {{ Math.max(job.total || 0, job.processed || 0).toLocaleString() }} &middot; {{ jobPct(job) }}%</div>
                <div
                  v-if="job.status === 'complete' && job.kind === 'email'"
                  class="stmt-queue-row__count"
                >{{ (job.sent || 0).toLocaleString() }} sent &middot;
                  {{ (job.failed || 0).toLocaleString() }} failed &middot;
                  {{ (job.skipped || 0).toLocaleString() }} skipped<template
                    v-if="job.redirected"> &middot;
                  {{ job.redirected.toLocaleString() }} redirected (non-prod)</template></div>
                <div
                  v-else-if="job.status === 'complete'"
                  class="stmt-queue-row__count"
                >{{ (job.processed || job.total || 0).toLocaleString() }} records printed</div>
                <v-progress-linear
                  v-if="job.status === 'running' || job.status === 'pending'"
                  :value="jobPct(job)"
                  height="3"
                  color="primary"
                  rounded
                  class="mt-1"
                />
                <div v-if="job.status === 'error'" class="stmt-queue-row__err">
                  {{ job.errorMessage || 'Error' }}
                </div>
              </div>
              <v-btn
                v-if="job.status === 'stalled'"
                x-small
                depressed
                color="warning"
                @click="checkStatementJob(job)"
                class="stmt-queue-row__pdf"
              >Check again</v-btn>
              <!-- An email run produces a log, not a PDF, and the log is worth opening while
                   the run is still going — that is where the failures show up. -->
              <v-btn
                v-else-if="job.kind === 'email'"
                x-small
                depressed
                color="primary"
                @click="openEmailRunLog(job)"
                class="stmt-queue-row__pdf"
              >Log</v-btn>
              <v-btn
                v-else
                x-small
                depressed
                :color="job.status === 'complete' ? 'primary' : 'grey lighten-2'"
                :disabled="job.status !== 'complete'"
                @click="job.status === 'complete' && downloadStatementPdf(job)"
                class="stmt-queue-row__pdf"
              >PDF</v-btn>
              <v-btn
                icon
                x-small
                :title="isJobRunning(job) ? 'Cancel this job' : 'Remove from list'"
                @click="cancelStatementJob(job)"
              >
                <v-icon size="13">{{ icons.mdiClose }}</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

      </v-col>
    </v-row>
    <BrowseTrWorkFileFooter ref="trFooter" :baseCrudKey="baseCrudKey"
     :handletrWorkFileRecords="handletrWorkFileRecords" />
    <TaxWarrantsCreateDialogTRWork :baseCrudKey="dialogCrudKey" :gridCrudKey="baseCrudKey" />
    <CommonPopUp v-model="showOrHideDialog" v-if="showOrHideDialog"
      :enableFlashTypeMsg="true" flashType="warning">
      <template v-slot:customsLabelOrInfo>
        <p class="mt-3">Records with Sale Year: {{ resaleCriteriaItem.saleYear }} already exits,
           would you like to replace it?</p>
      </template>
      <template v-slot:[`customsButtonsForPopUp`]="{}">
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="openConfirmPopUp('Yes')">Yes</v-btn>
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="openConfirmPopUp('No')">No</v-btn>
      </template>
    </CommonPopUp>
    <TaxRollDialogForBrowswTRWorkFile :tabsList="tabsList" :userName="userName"
     :wkstNumber="wkstNumber" />
    <TrWorkFileExportDialog
      :closeDialogBox.sync="showCronDialog"
      @settingDialogVal="showCronDialog = $event"
      baseCrudKey="browsePageCronJob"
      :rowItem.sync="cronJobItem"
    />
  </v-container>
</template>

<script>
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import { mdiCheckCircle, mdiAlertCircle, mdiClose } from '@mdi/js';
import '../../../assets/style.css';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import BrowseTrWorkFileFooter from './BrowseTrWorkFileFooter.vue';
import { tabsForTaxRollWorkFile, TaxRollWorkFileHeaders } from './utils/trWorkFileHeaders';
// import TaxWarrantCreateDialog from '../TaxInquiry/Common/TaxWarrantsCreateDialog.vue';
import { toIsoDate, toShortDate } from '../../../util/shared/tmc-global';
import { resaleConfigScope } from '../../../util/shared/system-config-scopes';
import {
  amountFormat, amountToNumber,
  defaultGridLoading, manageGridLoading,
} from '../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../util/workstation-util';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import CommonPopUp from '../common-utils/CommonPopUp.vue';
import { handleColorChange, makeCriteriaStateNullIfEmptyString, taxPostProcessFeesList } from '../common-utils/CommonTaxFunctionalities';
import loader from '../common-utils/loader.vue';
import TaxWarrantsCreateDialogTRWork from '../TaxInquiry/Common/TaxWarrantsCreateDialogTRWork.vue';
import BrowseTREditedItemVue from './BrowseTREditedItem.vue';
import TaxRollDialogForBrowswTRWorkFile from './TaxRollDialogForBrowswTRWorkFile.vue';
import { browsTrActionList } from './utils/BrowseTrActions';
import { resolveTrWorkFileSort } from '../warrants/utils/taxWarrants.util';
import TrWorkFileExportDialog from '../../import/TrWorkFileExportDialog.vue';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import { clients } from '../../../util/clients';

const { backendRest } = clients.direct;

export default {
  name: 'BrowseTrWorkFile',
  mixins: [GlobalToCaps],
  components: {
    CRUDList,
    BrowseTrWorkFileFooter,
    TaxWarrantsCreateDialogTRWork,
    BrowseTREditedItemVue,
    CommonDropDowns,
    ClarionDateControl,
    CommonPopUp,
    loader,
    TaxRollDialogForBrowswTRWorkFile,
    TrWorkFileExportDialog,
  },
  data() {
    return {
      // Vuetify runs with iconfont 'mdiSvg', so icons must be SVG paths rather than
      // `mdi-close` strings — a name string renders nothing at all.
      icons: { mdiCheckCircle, mdiAlertCircle, mdiClose },
      selectedRows: [],
      selectedRow: null,
      headers: TaxRollWorkFileHeaders,
      baseCrudKey: 'browseListNames',
      dialogCrudKey: 'personalTaxWarrantCreate',
      gridLoading: defaultGridLoading(),
      penaltyStartDate: null,
      effectiveDate: toShortDate(),
      addOneFeePerParcel: false,
      addOneFeePerOwner: false,
      getComment: '',
      actionButtons: browsTrActionList,
      loading: false,
      // a Go (or the June Resale "replace" Yes) is running, from the click until its request returns
      isActionRunning: false,
      showOrHideDialog: false,
      showCronDialog: false,
      cronJobItem: {},
      selActionIdex: 0,
      jumpToValue: '',
      jumpToColumnLabels: {
        taxId: 'Tax ID',
        ownerName: 'Owner Name',
        propertyOrParcelId: 'Parcel ID',
      },
      baseCrudKeyForTaxInquiry: 'TaxrollTransactionList',
      baseCrudKeyForFeeList: 'TaxrollTransactionFeeList',
      tabsList: [...tabsForTaxRollWorkFile],
      userName: '',
      wkstNumber: '',
      resaleCriteriaItem: {
        saleYear: null,
        saleDate: null,
        publicationDate: null,
        penaltyDate: toShortDate(),
      },
    };
  },
  async created() {
    this.wkstNumber = getWorkstationNumber();
    this.loadConfig({ requiredScope: 'statementConfig' });
    await this.loadConfig({ requiredScope: 'resaleConfig' });
    await this.loadLists();
    this.editedItem.taxYear = this.editedItem.taxYear || this.latestTaxYear;
    this.resaleCriteriaItem.saleYear = this.resaleSettingItem.resaleSaleYear;
    this.resaleCriteriaItem.saleDate = this.resaleSettingItem.resaleSaleDate;
    this.resaleCriteriaItem.publicationDate = this.resaleSettingItem.resalePublicationDate;
    this.userName = this.authUser;
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'items',
      'item',
      'paginationItems',
    ]),
    ...mapGetters('user', ['getSettings']),
    ...mapGetters('auth/token', ['authUser', 'isTaxAdminAccessible', 'authUserRoles']),
    // The queue is rendered newest-first; the store keeps the order the jobs were added in.
    ...mapGetters('tax/trWorkFile', { statementJobs: 'statementJobsNewestFirst' }),
    ...mapState({
      StoreSelItems: (state) => state.tax.trWorkFile.selectedItems,
      StoreTotalCount: (state) => state.tax.trWorkFile.totalTRRecordsCount,
      StoreTotalParcelCount: (state) => state.tax.trWorkFile.totalTRParcelCount,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      resaleSettingItem: (state) => state.SystemConfig.resaleSettingItem || {},
      nextWarrantNumber: (state) => state.tax.taxWarrants.nextWarrantNumber,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    formatPidPositions() {
      return this.taxSettingItem.pidValue || '';
    },
    getListNames() {
      const items = this.items('profileListNames');
      const updatedItem = items.filter((el) => el.name !== null)
        .map((el) => el.name);
      return updatedItem.sort();
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    selectedRecordsCount: {
      get() {
        return this.StoreTotalCount;
      },
      set(value) {
        this.settotalTRRecordsCount(value);
      },
    },
    selectedParcelCount: {
      get() {
        return this.StoreTotalParcelCount;
      },
      set(value) {
        this.settotalTRRecordsCount(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    getItemsList: {
      get() {
        return this.items(this.baseCrudKey);
      },
      set(value) {
        this.setItems([this.baseCrudKey, value]);
      },
    },
    listNames() {
      let listNames = [];
      if (this.getItemsList.length > 0) {
        listNames = this.getItemsList
          .filter((el) => el.name !== null)
          .map((el) => el.name);
      }
      return listNames;
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'totalDue',
          direction: 'desc',
        },
      ];
    },
    isSuperAdmin() {
      return (this.authUserRoles || []).includes('TmcSupport');
    },
    // Jump To must follow whatever the grid is CURRENTLY sorted by - handletrWorkFileRecords
    // (filter-driven sort) and CRUDList's column-click sort both flow through setCriteria into
    // this same store slot, so criteriaState.sortBy is always the live answer.
    currentSortBy() {
      return resolveTrWorkFileSort(this.criteriaState);
    },
    jumpFieldSupported() {
      return Object.prototype.hasOwnProperty.call(
        this.jumpToColumnLabels,
        this.currentSortBy.column,
      );
    },
    jumpToLabel() {
      const label = this.jumpToColumnLabels[this.currentSortBy.column];
      return label ? `Jump to ${label}` : 'Jump To (sort by Tax ID, Owner Name or Parcel ID)';
    },
    rules() {
      return [
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
  },
  watch: {
    // The two dedupe modes are alternatives, not a combination: when both arrive the backend's
    // if/else chain silently lets per-parcel win and ignores per-owner, so only one can ever be
    // ticked here. They stay checkboxes rather than radios because both-unticked (one fee per
    // work-file record) is a normal state the user has to be able to get back to.
    addOneFeePerParcel(isChecked) {
      if (!isChecked) return;
      this.addOneFeePerOwner = false;
      this.clearTaxYearForFeeAdd();
    },
    addOneFeePerOwner(isChecked) {
      if (!isChecked) return;
      this.addOneFeePerParcel = false;
      this.clearTaxYearForFeeAdd();
    },
  },
  methods: {
    ...mapActions(['custumColrFlashMsg']),
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setItems',
      'setItem',
    ]),
    ...mapMutations('tax/trWorkFile', [
      'setSelectedItems',
      'settotalTRRecordsCount',
      'removeStatementJob',
      'updateStatementJob',
    ]),
    ...mapActions('tax/trWorkFile', [
      'loadTRWorkFileBrowseList',
      'loadProfileList',
      'upsertTRWorkFileNewRecord',
      'deleteBrowseTrFileRecord',
      'updateTrBrowseListActions',
      'upsertCommentsBulk',
      'removePaidRecordsBrowseTrFile',
      'removeOverpaidRecordsBrowseTrFile',
      'addFeeRecordsInBulk',
      'previewAddFeeRecordsInBulk',
      'deleteFeeRecordsInBulk',
      'addDelinquentRecordsInBulk',
      'createJuneResaleRecords',
      'assignCertNumber',
      'loadPickListDataInTr',
      'deleteRecordsFromTrBasedOnFileName',
      'deleteRecordsFromTrBasedOnIds',
      'jumpToTrWorkFileRecord',
    ]),
    ...mapActions('tax/taxFee', [
      'loadTaxRollFeesTable',
      'upsertTaxFees',
      'deleteTaxFees',
      'taxFeesBasedOnIds',
    ]),
    ...mapActions('tax/taxPayment', [
      'upsertTaxPayment',
      'loadTaxPayments',
    ]),
    ...mapActions('tax/taxInquires', [
      'loadTaxInquires',
    ]),
    ...mapActions('tax/taxInquiryTabs', [
      'UpsertPickListSingleNMultiplipleHybrid',
      'loadTabsAdjustments',
    ]),
    ...mapActions('tax/taxComments', ['loadTaxComments', 'upsertTaxCommentTrans']),
    ...mapMutations('tax/taxInquiryTabs', ['setComments']),
    ...mapActions('tax/taxWarrants', [
      'loadLastWarrantNo', 'loadLastSystemID',
    ]),
    ...mapActions('shared/taxLevy', [
      'loadTaxLevy',
    ]),
    ...mapMutations('tax/taxInquires', [
      'setTaxRateTaxInquiry',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
      'setHighlightedId',
    ]),
    ...mapActions('SystemConfig', [
      'updateConfig', 'loadConfig',
    ]),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async handleMultipleDelete() {
      const ids = (this.selectedItems || []).map((item) => item._id);
      if (ids.length) {
        if (window.confirm('Are you sure you want to delete the selected records?')) {
          const item = { ids };
          await this.deleteRecordsFromTrBasedOnIds({ item });
          this.handletrWorkFileRecords();
        }
      } else this.custumColrFlashMsg({ msg: 'Please select a record' });
    },
    jobPct(job) {
      const denom = Math.max(job.total || 0, job.processed || 0);
      const raw = denom ? Math.round((job.processed / denom) * 100) : 0;
      const isRunning = job.status === 'running' || job.status === 'pending';
      return isRunning ? Math.min(99, raw) : Math.min(100, raw);
    },
    async handleMultipleDeleteByFileName() {
      if (this.criteriaState.name) {
        if (window.confirm('Are you sure you want to delete the selected records?')) {
          const item = { name: this.criteriaState.name };
          await this.deleteRecordsFromTrBasedOnFileName({ item });
          // resetting the selected file dropdown
          await this.loadLists();
          this.criteriaState.name = '';
          this.setItems([this.baseCrudKey, []]);
          this.selectedItems = [];
        }
      } else this.custumColrFlashMsg({ msg: 'Please select a record' });
    },
    onChangeActionVal(val) {
      this.selActionIdex = val;
    },
    async handleWarrantDialog() {
      const newItem = {
        sherifFee: (this.taxSettingItem.sherifFee || '').toString(),
        sherifFeeAmount: amountToNumber(this.taxSettingItem.sherifFeeAmount),
        treasureFee: (this.taxSettingItem.treasurerFee || '').toString(),
        treasureFeeAmount: amountToNumber(this.taxSettingItem.treasurerFeeAmount),
        warrantNumber: this.nextWarrantNumber,
        aliasNumber: 1,
        issueDate: toIsoDate(new Date()),
        penaltyDate: toIsoDate(new Date()),
      };
      this.setItem([this.dialogCrudKey, newItem]);
      await this.setIsVisible([this.dialogCrudKey, true]);
      await this.loadLastWarrantNo();
      await this.loadLastSystemID();
    },
    // async handletrWorkFileRecords() {
    //   const { baseCrudKey } = this;
    //   const criteria = {
    //     ...this.criteriaState,
    //     wkstID: Number(this.wkstNumber),
    //   };
    async handletrWorkFileRecords() {
      let criteria;
      const { baseCrudKey } = this;
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      if (this.criteriaState.fromTaxId || this.criteriaState.toTaxId) {
        criteria = {
          ...this.criteriaState,
          // wkstID: Number(this.wkstNumber),
          sortBy: [
            {
              column: 'taxId',
              direction: 'asc',
            },
          ],
        };
      } else if (this.criteriaState.taxYearFrom || this.criteriaState.taxYearTo) {
        criteria = {
          ...this.criteriaState,
          // wkstID: Number(this.wkstNumber),
          sortBy: [
            {
              column: 'taxYear',
              direction: 'asc',
            },
          ],
        };
        // this.handletrWorkFileRecords(criteriatoApply);
      } else if (this.criteriaState.ownerNameFrom || this.criteriaState.ownerNameTo) {
        criteria = {
          ...this.criteriaState,
          // wkstID: Number(this.wkstNumber),
          sortBy: [
            {
              column: 'ownerName',
              direction: 'asc',
            },
          ],
        };
      } else if (this.criteriaState.incfromMtgCode || this.criteriaState.inctoMtgCode) {
        criteria = {
          ...this.criteriaState,
          // wkstID: Number(this.wkstNumber),
          sortBy: [
            {
              column: 'mtgCode',
              direction: 'asc',
            },
          ],
        };
      } else if (this.criteriaState.parcelIdFrom || this.criteriaState.parcelIdTo) {
        criteria = {
          ...this.criteriaState,
          // wkstID: Number(this.wkstNumber),
          sortBy: [
            {
              column: 'propertyOrParcelId',
              direction: 'asc',
            },
          ],
        };
      } else {
        criteria = {
          ...this.criteriaState,
          // wkstID: Number(this.wkstNumber),
          // sortBy: [
        };
      }

      if (criteria && Object.prototype.hasOwnProperty.call(criteria, 'name') === true && criteria.name !== '') {
        manageGridLoading(this, true, 'Searching...');
        delete criteria.ids;
        await this.loadTRWorkFileBrowseList({ criteria, baseCrudKey }).finally(() => {
          manageGridLoading(this, false);
          this.$nextTick(() => {
            this.selectedItems = [];
          });
        });
      }
    },
    // Count-ahead navigation: ask the backend how many records (under the current filter/sort)
    // sit ahead of the typed value, then convert that position into a skip/page and highlight
    // the landing row - no filtering, no client-side search, the full list stays in the grid.
    async handleJumpTo() {
      if (!this.jumpFieldSupported || !this.jumpToValue) return;
      const { column, direction } = this.currentSortBy;
      const { baseCrudKey } = this;
      manageGridLoading(this, true, 'Jumping...');
      try {
        const response = await this.jumpToTrWorkFileRecord({
          criteria: this.criteriaState,
          jumpColumn: column,
          jumpValue: this.jumpToValue,
          jumpDirection: direction,
        });
        if (!response) return;
        const { position } = response;
        const itemsperpage = (this.paginationItems(baseCrudKey) || {}).itemsperpage
          || this.getSettings.itemsperpage;
        const page = Math.floor(position / itemsperpage) + 1;
        const rowIndex = position % itemsperpage;
        const criteria = {
          ...this.criteriaState,
          skip: (page - 1) * itemsperpage,
          limit: itemsperpage,
          sortBy: [{ column, direction }],
        };
        this.setCriteria([baseCrudKey, criteria]);
        await this.loadTRWorkFileBrowseList({ criteria, baseCrudKey });
        this.$nextTick(() => {
          const landedItem = this.getItemsList[rowIndex];
          if (landedItem) this.setHighlightedId([baseCrudKey, landedItem._id]);
        });
      } finally {
        manageGridLoading(this, false);
      }
    },
    async searchByCriteria() {
      if (this.criteriaState.name === '') this.getItemsList = [];
      await this.handletrWorkFileRecords();
    },
    openCronDialog() {
      this.cronJobItem = {
        description: this.criteriaState.name ? `Export ${this.criteriaState.name}` : '',
        destination: '/tax/trWorkFile/profile-export',
        jobKind: 'trWorkFileExport',
        params: {
          profileName: '',
          exportProfile: 'DELQ TAX CSV',
          listName: this.criteriaState.name
            ? `CRON_TRWF_${(this.criteriaState.name).replace(/[^A-Z0-9]/gi, '_').toUpperCase()}`
            : '',
          wkstID: 0,
          targetPath: '/data/exports/f/ascii/over-night-reports/$TODAY',
        },
        outputFilename: 'UnpaidTaxRecords_$TODAY_MMDDYYYY.csv',
        expectedRunTime: {
          days: '*', hrs: 2, mins: 0, secs: 0,
        },
        isActiveInactive: false,
      };
      this.showCronDialog = true;
    },
    async loadLists() {
      const criteria = {
        name: this.criteriaState.name,
        wkstID: Number(this.wkstNumber),
      };
      await this.loadProfileList({ criteria, baseCrudKey: 'profileListNames' });
    },
    async upsertTransaction(item) {
      const itemData = {
        ...item,
        wkstID: Number(this.wkstNumber),
        name: this.criteriaState.name,
      };
      const { baseCrudKey } = this;
      await this.upsertTRWorkFileNewRecord({ baseCrudKey, itemData });
      this.handletrWorkFileRecords();
    },
    async deleteItem(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        await this.deleteBrowseTrFileRecord({ item, baseCrudKey });
        this.handletrWorkFileRecords();
      }
    },
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
    // Nothing stops the same fee being applied to the same record twice, and "Add fees" is one
    // button that can be pressed again. At Canadian on 08/24/2026 a clerk who believed the first run
    // had failed ran it a second time; that time the fee really was applied, and the county was left
    // with two "fee was added" comments against one fee and no way to tell which run was real. A
    // genuine double-apply would have double-charged every record in the file.
    //
    // Asks rather than blocks - a county can legitimately charge the same fee twice - and proceeds
    // if the preview itself cannot be read, so a failing count never becomes a reason the add
    // cannot run at all.
    async confirmFeeAddIsNotARerun(itemToSent) {
      const preview = await this.previewAddFeeRecordsInBulk({ itemToSent });
      if (!preview || !preview.alreadyCarryingFeeCount) return true;
      const { requestedCount, alreadyCarryingFeeCount } = preview;
      return window.confirm(
        `${alreadyCarryingFeeCount} of the ${requestedCount} record(s) in this work file already carry fee `
        + `${itemToSent.feeNumber}.\n\nContinuing adds a SECOND fee of $${itemToSent.feeAmount} to each of them. `
        + 'If you are re-running this because the first attempt looked like it failed, check the records first '
        + '- it may have worked.\n\nAdd the fee anyway?',
      );
    },
    // Ticking either dedupe box makes the fee add span every tax year (buildAddFeesFromTr drops the
    // year filter for those modes), so the year selection is cleared to '(all years)' -- the user has
    // to SEE that it no longer applies instead of it being stripped from the payload behind their
    // back. The dropdown stays enabled on purpose: re-picking a year while a box is ticked is allowed
    // and is simply disregarded server-side.
    clearTaxYearForFeeAdd() {
      // 0 is the '(all years)' item. null would NOT read as blank -- CommonDropDowns falls back to
      // the configured/latest tax year for null and only treats 0 as an explicit "all years".
      // Replace the whole item rather than assigning the property: taxYear is added to the store's
      // item object by plain assignment, so it is not a reactive key and the v-select would not
      // re-render. setItem swaps the object wholesale, which does re-render.
      this.editedItem = { ...this.editedItem, taxYear: 0 };
    },
    roundAmount() {
      this.editedItem.feeAmount = amountFormat(amountToNumber(this.editedItem.feeAmount));
    },
    amountToNum() {
      this.editedItem.feeAmount = amountToNumber(this.editedItem.feeAmount);
    },
    // one Go at a time: every action below starts a bulk change on the whole work file, and the
    // overlay (`loading`) is only raised when a record is selected
    async handleActions() {
      if (this.isActionRunning) return;
      this.isActionRunning = true;
      try {
        await this.runAction();
      } finally {
        this.isActionRunning = false;
      }
    },
    async runAction() {
      const selectedItem = this.item(this.baseCrudKey);
      if (Object.keys(selectedItem).length !== 0) {
        this.loading = true;
      }
      const { name } = this.criteriaState;
      if (this.selActionIdex === 1) {
        // await this.upsertTaxFees({ item, baseCrudKey: 'taxRollFeesTable' }).then(() => {
        //   const emptyObj = { feeAmount: null, feeNumber: 0 };
        //   this.setItem(['taxRollFeesTable', emptyObj]);
        // });
      }
      if (this.selActionIdex === 2) {
        const { mtgCode } = this.item(this.baseCrudKey);
        const itemToSent = {
          name,
          mtgCode,
          flag: 'mtgCode',
        };
        if (itemToSent.name && itemToSent.mtgCode) {
          await this.updateTrBrowseListActions({ itemToSent }).then(() => {
            this.loading = false;
            this.handletrWorkFileRecords();
          });
        } else this.loading = false;
      }
      if (this.selActionIdex === 8) {
        const itemToSent = {
          name,
          mtgCode: '',
          flag: 'mtgCode',
        };
        if (itemToSent.name) {
          await this.updateTrBrowseListActions({ itemToSent }).then(() => {
            this.loading = false;
            this.handletrWorkFileRecords();
          });
        } else this.loading = false;
      }
      if (this.selActionIdex === 3) {
        const { statusCode } = this.item(this.baseCrudKey);
        const itemToSent = {
          name,
          statusCode,
          flag: 'statusCode',
        };
        if (itemToSent.name && itemToSent.statusCode) {
          await this.updateTrBrowseListActions({ itemToSent }).then(() => {
            this.loading = false;
          });
        } else this.loading = false;
      }
      if (this.selActionIdex === 9) {
        const { statusCode } = this.item(this.baseCrudKey);
        const itemToSent = {
          name,
          statusCode,
          flag: 'removeStatusCode',
        };
        if (itemToSent.name && itemToSent.statusCode) {
          await this.updateTrBrowseListActions({ itemToSent }).then(() => {
            this.loading = false;
          });
        } else this.loading = false;
      }
      if (this.selActionIdex === 4) {
        const itemToSent = {
          name,
          penaltyStartDate: this.penaltyStartDate,
          flag: 'penaltyStartDate',
        };
        if (itemToSent.name && itemToSent.penaltyStartDate) {
          await this.updateTrBrowseListActions({ itemToSent }).then(() => {
            this.loading = false;
          });
        } else this.loading = false;
      }
      if (this.selActionIdex === 11) {
        const itemToSent = {
          name,
          penaltyStartDate: null,
          flag: 'penaltyStartDate',
        };
        if (itemToSent.name) {
          await this.updateTrBrowseListActions({ itemToSent }).then(() => {
            this.loading = false;
          });
        } else this.loading = false;
      }
      if (this.selActionIdex === 5) {
        const itemToSent = {
          name,
          comment: this.getComment,
        };
        if (itemToSent.name && itemToSent.comment) {
          await this.upsertCommentsBulk({ itemToSent }).then(() => {
            this.loading = false;
          });
        } else this.loading = false;
      }
      if (this.selActionIdex === 10) {
        const itemToSent = {
          name,
        };
        if (itemToSent.name) {
          await this.removePaidRecordsBrowseTrFile({ itemToSent }).then(() => {
            this.loading = false;
            this.handletrWorkFileRecords();
          });
        } else this.loading = false;
      }
      if (this.selActionIdex === 15) {
        const itemToSent = {
          name,
        };
        if (itemToSent.name) {
          await this.removeOverpaidRecordsBrowseTrFile({ itemToSent }).then(() => {
            this.loading = false;
            this.handletrWorkFileRecords();
          });
        } else this.loading = false;
      }
      if (this.selActionIdex === 1) {
        const { feeAmount } = this.item(this.baseCrudKey);
        const { feeNumber } = this.item(this.baseCrudKey);
        const { taxYear } = this.item(this.baseCrudKey);
        const itemToSent = {
          name,
          feeAmount: amountToNumber(feeAmount),
          feeNumber,
          taxYear: taxYear || null,
          effectiveDate: this.effectiveDate ? toIsoDate(this.effectiveDate) : null,
          addOneFeePerParcel: this.addOneFeePerParcel || false,
          addOneFeePerOwner: this.addOneFeePerOwner || false,
        };
        if (itemToSent.name && itemToSent.feeAmount && itemToSent.feeNumber) {
          await this.confirmFeeAddIsNotARerun(itemToSent).then(async (proceed) => {
            if (!proceed) {
              this.loading = false;
              return;
            }
            await this.addFeeRecordsInBulk({ itemToSent }).then(() => {
              this.loading = false;
              this.handletrWorkFileRecords();
            });
          });
        } else {
          this.loading = false;
        }
      }
      if (this.selActionIdex === 7) {
        const { feeNumber } = this.item(this.baseCrudKey);
        const { taxYear } = this.item(this.baseCrudKey);
        const itemToSent = {
          name,
          feeNumber,
          taxYear: taxYear || null,
        };
        if (itemToSent.name && itemToSent.feeNumber) {
          await this.deleteFeeRecordsInBulk({ itemToSent }).then(() => {
            this.loading = false;
            this.handletrWorkFileRecords();
          });
        } else {
          this.loading = false;
        }
      }
      if (this.selActionIdex === 6) {
        const itemToSent = {
          name,
        };
        await this.addDelinquentRecordsInBulk({ itemToSent }).then(() => {
          this.loading = false;
          this.handletrWorkFileRecords();
        });
      }
      if (this.selActionIdex === 14) {
        const itemToSent = {
          name,
        };
        await this.assignCertNumber({ itemToSent }).then(() => {
          this.loading = false;
          this.handletrWorkFileRecords();
        });
      }
      if (this.selActionIdex === 12) {
        this.loading = false;
        if (this.selectedItems.length > 0) {
          this.handleWarrantDialog();
        } else {
          this.custumColrFlashMsg({ msg: 'Please select any record!' });
        }

        // const itemToSent = {
        //   name,
        // };
        // this.addDelinquentRecordsInBulk({ itemToSent }).then(() => {
        //   this.loading = false;
        //   this.handletrWorkFileRecords();
        // });
      }
      if (this.selActionIdex === 13) {
        const {
          saleYear, publicationDate, saleDate, penaltyDate,
        } = this.resaleCriteriaItem;
        if (saleYear) {
          const itemToSent = {
            name,
            saleYear: Number(saleYear) || null,
            publicationDate: publicationDate ? toIsoDate(publicationDate) : null,
            penaltyDate: penaltyDate ? toIsoDate(penaltyDate) : null,
            saleDate: saleDate ? toIsoDate(saleDate) : null,
          };
          await this.createJuneResaleRecords({ itemToSent }).then(async (val) => {
            if (val.statusCode === 203) {
              this.showOrHideDialog = true;
            } else {
              await this.updateDatesInResaleSetting();
            }
            this.loading = false;
          });
        } else {
          this.loading = false;
          this.custumColrFlashMsg({ msg: 'Sale year is required' });
        }
      }
    },
    async updateDatesInResaleSetting() {
      const { publicationDate, saleDate, penaltyDate } = this.resaleCriteriaItem;
      const item = resaleConfigScope.mergeForPersist(this.resaleSettingItem, {
        resalePenaltyDate: penaltyDate,
        resalePublicationDate: publicationDate,
        resaleSaleDate: saleDate,
      });
      await this.updateConfig({ calledScope: 'resaleConfig', item });
    },
    openConfirmPopUp(fromWhere) {
      if (fromWhere === 'Yes') {
        const {
          saleYear, publicationDate, saleDate, penaltyDate,
        } = this.resaleCriteriaItem;
        const itemToSent = {
          name: this.criteriaState.name,
          saleYear: Number(saleYear) || null,
          publicationDate: publicationDate ? toIsoDate(publicationDate) : null,
          penaltyDate: penaltyDate ? toIsoDate(penaltyDate) : null,
          saleDate: saleDate ? toIsoDate(saleDate) : null,
          overRideTheSaleYearRecords: true,
        };
        if (this.isActionRunning) return;
        this.isActionRunning = true;
        this.loading = true;
        this.createJuneResaleRecords({ itemToSent }).then(async () => {
          this.loading = false;
          await this.updateDatesInResaleSetting();
        }).finally(() => {
          this.isActionRunning = false;
        });
        this.showOrHideDialog = false;
      } else this.showOrHideDialog = false;
    },
    async handlePickListRecords() {
      const pickListProfileName = localStorage.getItem('pick-list-profile-name') || '';
      const criteria = {
        ...this.criteriaState,
        wkstID: Number(this.wkstNumber),
        profileName: pickListProfileName,
      };
      const { baseCrudKey } = this;
      await this.loadPickListDataInTr({ criteria, baseCrudKey });
      const cri = {
        ...this.criteriaState,
        name: 'pickList',
      };
      this.setCriteria([this.baseCrudKey, cri]);
      this.handletrWorkFileRecords(cri);
    },
    resetStoreItems() {
      // to reset when criteria changes
      this.setItems(['TaxRollDelq', []]);
      this.setItems(['TaxRollStatusCodes', []]);
      this.setItems(['paymentsRecords', []]);
      this.setItems(['GeneralDetailsPayments', []]); // for taxinfo-payment
      this.setItems(['taxRollComments', []]);
    },
    resetTabsList() {
      const mappedArr = (tabsForTaxRollWorkFile || []).map((ft) => {
        const item = ft;
        item.color = '';
        return item;
      });
      this.tabsList = mappedArr; // reseting tabs
    },
    setDefaultComments() {
      this.$nextTick(() => {
        this.setComments([]);
      });
    },
    isJobRunning(job) {
      return ['running', 'pending', 'queued', 'stalled'].includes(job.status);
    },
    // A queue row can be a statement print, a pick list print or a bulk email run. The base
    // path and the id segment differ; everything else about the row does not.
    jobUrl(job, suffix = '') {
      if (job.kind === 'email') {
        return `taxInquiry/pick-list/emailStatement/run/${job.jobId}${suffix}`;
      }
      const base = job.kind === 'picklist'
        ? 'taxInquiry/pick-list/printlist'
        : 'taxInquiry/pick-list/printStatement';
      return `${base}/job/${job.jobId}${suffix}`;
    },
    // Closing a row used to only hide it: the job kept rendering and kept holding one of
    // the two concurrent slots for the whole county. Tell the server first.
    async cancelStatementJob(job) {
      if (this.isJobRunning(job) && job.jobId) {
        try {
          await backendRest.get(this.jobUrl(job, '/cancel'));
        } catch (err) {
          // Already finished or already gone — removing the row is still the right outcome.
        }
      }
      this.removeStatementJob(job.localId);
    },
    // The per-record log for a bulk email run. Lives in the footer, which owns the dialog.
    openEmailRunLog(job) {
      if (this.$refs.trFooter) this.$refs.trFooter.openEmailRunLog(job);
    },
    // Ask the server where a stalled job actually landed instead of leaving the user with
    // "it may still be running". The footer's watcher re-attaches polling if it is alive.
    async checkStatementJob(job) {
      if (!job.jobId) return;
      try {
        const response = await backendRest.get(this.jobUrl(job));
        const {
          status, processed, total, pdfUrl, errorMessage,
        } = response.data;
        this.updateStatementJob({
          localId: job.localId,
          updates: {
            status,
            processed: processed || 0,
            total: total || 0,
            pdfUrl: pdfUrl ? `${backendRest.defaults.baseURL}/${pdfUrl}` : null,
            errorMessage: errorMessage || null,
          },
        });
      } catch (err) {
        const gone = err && err.response && err.response.status === 404;
        this.updateStatementJob({
          localId: job.localId,
          updates: {
            status: 'error',
            errorMessage: gone
              ? 'This job is no longer on the server — please re-run the statement.'
              : 'Could not reach the server to check this job.',
          },
        });
      }
    },
    async downloadStatementPdf(job) {
      if (!job.pdfUrl) return;
      if (!job.pdfUrl.includes('/download/')) {
        this.custumColrFlashMsg({ msg: 'Invalid PDF URL. Please try again.' });
        return;
      }
      try {
        const tokenUrl = job.pdfUrl.replace('/download/', '/download-token/');
        const { data } = await backendRest.get(tokenUrl);
        window.open(`${job.pdfUrl}?dt=${data.token}`, '_blank');
      } catch (err) {
        this.custumColrFlashMsg({ msg: 'Failed to open PDF. Please try again.' });
      }
    },
    async handleDoubleClick(item) {
      this.resetTabsList();

      const { baseCrudKeyForTaxInquiry, baseCrudKeyForFeeList } = this;
      const criteria = {
        taxYear: item.taxYear,
        taxId: item.taxId,
      };

      await this.loadTaxInquires({
        criteria,
        baseCrudKey: baseCrudKeyForTaxInquiry,
        postProcessTrans: this.taxPostProcessTrans,
      }).then(async (val) => {
        // get the record
        if (val.length) {
          const retItem = val[0];
          retItem.penaltyDateValue = toShortDate();
          this.setItem([baseCrudKeyForTaxInquiry, retItem || {}]);
          this.resetStoreItems();
          const itemsList = val;
          // to filter only the still due tax records
          const filterUnPaidTaxes = (itemsList || [])
            .filter((ft) => amountToNumber(ft.totalDue) > 0);
          if (filterUnPaidTaxes.length) {
            const ids = filterUnPaidTaxes.map((ft) => ft._id);
            await this.taxFeesBasedOnIds(
              {
                criteria: { ids },
                baseCrudKey: baseCrudKeyForFeeList,
                postProcessTrans: taxPostProcessFeesList,
              },
            );
          }
          const doesItHasMobileListOrNot = [];
          if (Number(val.mobileHome || 0) > 0) {
            doesItHasMobileListOrNot.push(doesItHasMobileListOrNot);
          }
          const returnedList = handleColorChange(
            'Mobile',
            doesItHasMobileListOrNot,
            tabsForTaxRollWorkFile,
          );
          this.tabsList = [...returnedList];
          this.loadTaxPayments({ criteria, baseCrudKey: 'GeneralDetailsPayments' }); // for taxinfo-payment
          this.loadTaxRollFeesTable({
            criteria,
            baseCrudKey: 'taxRollFeesTable',
            postProcessTrans: this.taxFeesPreProcessTrans,
          });
          this.loadTaxComments({
            criteria,
            baseCrudKey: this.commentsTransCrudKey,
            postProcessTrans: this.postProcessTrans,
          }).then(() => {
            this.setDefaultComments();
          });
          const returnedAdjArr = await this.loadTabsAdjustments({
            criteria,
            baseCrudKey: 'TaxRollAdjustments',
          });
          const returnedAdjList = handleColorChange(
            'Adjustments',
            returnedAdjArr,
            tabsForTaxRollWorkFile,
          );
          this.tabsList = [...returnedAdjList];
          let taxLevyTotal = null;
          if (val.schoolDistrict && this.taxDistrict) {
            const filDist = this.taxDistrict.filter((ft) => ft.districtCode
          === val.schoolDistrict);
            if (filDist.length) {
              const critLevy = {
                taxDistrict: filDist[0]._id,
                taxYear: val.taxYear,
              };
              const taxLevyData = await this.loadTaxLevy({
                criteria: critLevy,
              });
              if (taxLevyData.length) {
                taxLevyTotal = taxLevyData
                  .reduce((acc, items) => acc + amountToNumber(items.mills || 0), 0);
              }
            }
          }
          this.setTaxRateTaxInquiry(taxLevyTotal);
          this.setIsVisible([baseCrudKeyForTaxInquiry, true]);
        }
      });
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.ctnr {
  border: 1px solid black;
  margin-top: 1rem;
}

.list-btns-ctnr {
  display: flex;
  flex-direction: row;
  gap: 2rem;
}

.list-action-btns {
  display: block;
  gap: 1rem;
  margin-bottom: 0.5rem;
  border: 1px solid lightgray;
  padding: 0.5rem;
}
.stmt-queue {
  display: flex;
  flex-direction: column;
  gap: 6px;
  /* The queue shares a row with the record grid, so an unbounded list of jobs stretched the
     row and pushed the Print / Statement Settings panels far down the page. Cap it and let
     the jobs scroll instead. */
  max-height: 320px;
  overflow-y: auto;
  padding-right: 2px; /* keeps the scrollbar off the row borders */
}
.stmt-queue-row {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
  padding: 7px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #ffffff;
  animation: stmt-fade-in 0.18s ease-out;
}
@keyframes stmt-fade-in {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}
.stmt-queue-row__left {
  flex-shrink: 0;
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stmt-queue-row__body {
  flex: 1;
  min-width: 0;
}
.stmt-queue-row__label {
  font-size: 11px;
  color: #424242;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.stmt-queue-row__count {
  font-size: 10px;
  color: #757575;
  margin-top: 1px;
}
.stmt-queue-row__err {
  font-size: 10px;
  color: #e53935;
  margin-top: 2px;
}
.stmt-queue-row__pdf {
  flex-shrink: 0;
  font-size: 10px !important;
}

.btns-ctnr {
  display: flex;
  flex-direction: row;
  gap: 5rem;
}

.btns {
  display: flex;
  width: 100%;
  gap: 0.4rem;
}

.list-actions-ref {
  border-top: 1px solid lightgray;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  display: flex;
  flex-direction: column;

}

.flex {
  display: flex;
  flex-direction: row;
  gap: 2px;
}

.totals-display {
  display: flex;
  align-items: center;
  font-weight: 500;
  letter-spacing: 0.5px;
  gap: 20px;
}

.total-item {
  padding: 3px 0;
}
</style>
